export function createVideoPosterFromFile(file) {
  return new Promise((resolve) => {
    const objectUrl = URL.createObjectURL(file);
    const video = document.createElement('video');
    video.muted = true;
    video.playsInline = true;
    video.preload = 'auto';

    const cleanup = () => {
      URL.revokeObjectURL(objectUrl);
      video.removeAttribute('src');
      video.load();
    };

    const fail = () => {
      cleanup();
      resolve(null);
    };

    video.onerror = fail;

    video.onloadeddata = () => {
      const seekTime = Number.isFinite(video.duration) ? Math.min(0.1, video.duration / 2) : 0.1;
      video.currentTime = seekTime;
    };

    video.onseeked = () => {
      const { videoWidth, videoHeight } = video;

      if (!videoWidth || !videoHeight) {
        fail();
        return;
      }

      const canvas = document.createElement('canvas');
      canvas.width = videoWidth;
      canvas.height = videoHeight;

      const ctx = canvas.getContext('2d');

      if (!ctx) {
        fail();
        return;
      }

      ctx.drawImage(video, 0, 0, videoWidth, videoHeight);

      canvas.toBlob(
        (blob) => {
          cleanup();
          resolve(blob ? URL.createObjectURL(blob) : null);
        },
        'image/jpeg',
        0.85,
      );
    };

    video.src = objectUrl;
  });
}
